<template>
  <div>
    <a-form class="mb-3" :form="form" @submit="handleSubmit">
      <p class="neo_form_sub_heading">Personal Details <strong>(As per HSLC certificate or equivalent exam)</strong></p>
      <div class="row pb-3">
        <div class="col-md-6">
          <a-form-item label="Full name">
          <a-input
            placeholder="Full name"
            v-decorator="['student_first_name', {rules: [{ required: true, message: 'Please input name!' }]}]"
          />
          </a-form-item>
        </div>
        <!-- <div class="col-md-4">
          <a-form-item label="Last name">
          <a-input
            placeholder="Last name"
            v-decorator="['student_last_name', {rules: [{ required: true, message: 'Please input last name!' }], initialValue: '.'}]"
          />
          </a-form-item>
        </div> -->

        <div class="col-md-4">
          <a-form-item
            label="Date of birth"
          >
          <a-date-picker
            v-decorator="[
            'dob',
            {rules: [{ required: true, message: 'Please input date of birth' }]},
            ]"
            :disabled-date="disabledDate"
            :format=dateFormat />
          </a-form-item>
        </div>

        <div class="col-md-4">
          <a-form-item label="Nationality">
            <a-select
              v-decorator="[
                'nationality',
                {rules: [{ required: false, message: 'Please select a nationality!' }], initialValue: 'Indian'}
              ]"
            >
              <a-select-option value="Indian">
                Indian
              </a-select-option>
              <a-select-option value="Other">
                Other
              </a-select-option>
            </a-select>
          </a-form-item>
        </div>

        <div class="col-md-4">
          <a-form-item label="Religion">
          <a-select
              v-decorator="[
                'religion',
                {rules: [{ required: true, message: 'Please select a religion!' }], initialValue: 'Hindu'}
              ]"
            >
              <a-select-option value="Hindu">
                Hindu
              </a-select-option>
              <a-select-option value="Muslim">
                Muslim
              </a-select-option>
              <a-select-option value="Christain">
                Christain
              </a-select-option>
              <a-select-option value="Jain">
                Jain
              </a-select-option>
              <a-select-option value="Persian">
                Persian
              </a-select-option>
              <a-select-option value="Sikh">
                Sikh
              </a-select-option>
              <a-select-option value="Buddhism">
                Buddhism
              </a-select-option>
              <a-select-option value="Other">
                Other
              </a-select-option>
            </a-select>
          </a-form-item>
        </div>

        <div class="col-md-3">
          <a-form-item
            label="Gender"
          >
            <a-radio-group
              v-decorator="[
                'gender',
                {rules: [{ required: false, message: 'Please select a gender!' }],
                initialValue: 'M'},
              ]"
            >
              <a-radio v-for="genderType in genderTypes" :value="genderType.value" :key="genderType.value" class="mr-2">
                <span class="text-bold">{{genderType.name}}</span>
              </a-radio>
            </a-radio-group>
          </a-form-item>
        </div>

        <div class="col-md-5">
          <a-form-item
            label="Category"
          >
            <a-radio-group
              v-decorator="[
                'category',
                {rules: [{ required: false, message: 'Please select a category!' }],
                initialValue: 'GEN'},
              ]"
            >
              <a-radio v-for="categoryType in categoryTypes" :value="categoryType.value" :key="categoryType.value" class="mr-2">
                <span class="text-bold">{{categoryType.name}}</span>
              </a-radio>
            </a-radio-group>
          </a-form-item>
        </div>

        <div class="col-md-3">
          <a-form-item label="Below poverty Line (BPL)">
            <a-select
              v-decorator="[
                'bpl',
                {rules: [{ required: true, message: 'Please select an option!' }], initialValue: 0}
              ]"
            >
              <a-select-option :value="0">
                No
              </a-select-option>
              <a-select-option :value="1">
                Yes
              </a-select-option>
            </a-select>
          </a-form-item>
        </div>

        <div class="col-md-3">
          <a-form-item label="Mother Tongue">
          <a-input
            placeholder="Language"
            v-decorator="['language', {rules: [{ required: false, message: 'Please input mother tongue!' }]}]"
          />
          </a-form-item>
        </div>

        <div class="col-md-4">
          <a-form-item label="Aadhaar No.">
          <a-input
            placeholder="Aadhaar No."
            v-decorator="['aadhaar_no', {rules: [{ required: true, message: 'Please input aadhaar number!', pattern: new RegExp(`^[0-9]{12}$`) }]}]"
          />
          </a-form-item>
        </div>

        <div class="col-md-2">
          <a-form-item label="Require bus pickup">
            <a-select
              v-decorator="[
                'require_transport',
                {rules: [{ required: true, message: 'Please select an option!' }], initialValue: 0}
              ]"
            >
              <a-select-option :value="0">
                No
              </a-select-option>
              <a-select-option :value="1">
                Yes
              </a-select-option>
            </a-select>
          </a-form-item>
        </div>

        <div class="col-md-6" v-show="form.getFieldValue(`require_transport`)">
          <a-form-item label="Prefered transport pickup location">
          <a-input
            placeholder="Pickup location"
            v-decorator="['transport_pickup_point', {rules: [{ required: form.getFieldValue(`require_transport`), message: 'Please input a pickup point!' }]}]"
          />
          </a-form-item>
        </div>

        <div class="col-md-4">
          <a-form-item label="Any tattoo on visible part of body?">
            <a-select
              v-decorator="[
                'visible_tattoo',
                {rules: [{ required: true, message: 'Please select an option!' }], initialValue: 0}
              ]"
            >
              <a-select-option :value="0">
                No
              </a-select-option>
              <a-select-option :value="1">
                Yes
              </a-select-option>
            </a-select>
          </a-form-item>
        </div>

        <div class="col-md-3">
          <a-form-item label="Differently Abled Person">
            <a-select
              v-decorator="[
                'disabled',
                {rules: [{ required: true, message: 'Please select an option!' }], initialValue: 0}
              ]"
            >
              <a-select-option :value="0">
                No
              </a-select-option>
              <a-select-option :value="1">
                Yes
              </a-select-option>
            </a-select>
          </a-form-item>
        </div>

        <div class="col-md-3">
          <a-form-item label="Orphan?">
            <a-select
              v-decorator="[
                'orphan',
                {rules: [{ required: true, message: 'Please select an option!' }], initialValue: 0}
              ]"
            >
              <a-select-option :value="0">
                No
              </a-select-option>
              <a-select-option :value="1">
                Yes
              </a-select-option>
            </a-select>
          </a-form-item>
        </div>

      </div>

      <a-divider />
      <p class="neo_form_sub_heading pt-3">Contact Details <strong>(Present address)</strong></p>
      <div class="row pb-3">
        <div class="col-md-9">
          <a-form-item label="Address">
          <a-input
            placeholder="Street address"
            v-decorator="['contact_address', {rules: [{ required: true, message: 'Please input school address!' }]}]"
          />
          </a-form-item>
        </div>

        <div class="col-md-3">
          <a-form-item label="City">
          <a-input
            placeholder="City"
            v-decorator="['contact_city', {rules: [{ required: false, message: 'Please input city!' }]}]"
          />
          </a-form-item>
        </div>

        <div class="col-md-3">
          <a-form-item label="District">
          <a-input
            placeholder="District"
            v-decorator="['contact_district', {rules: [{ required: false, message: 'Please input a district!' }]}]"
          />
          </a-form-item>
        </div>

        <div class="col-md-3">
          <a-form-item label="Landmark">
          <a-input
            placeholder="Landmark"
            v-decorator="['contact_landmark',]"
          />
          </a-form-item>
        </div>

        <div class="col-md-3">
          <a-form-item label="Pincode">
          <a-input
            placeholder="Pincode"
            v-decorator="['contact_pincode', {rules: [{ required: false, message: 'Please input a pincode!' }]}]"
          />
          </a-form-item>
        </div>

        <div class="col-md-3">
          <a-form-item label="State">
          <a-input
            placeholder="State"
            v-decorator="['contact_state', {rules: [{ required: true, message: 'Please input a state!' }]}]"
          />
          </a-form-item>
        </div>

        <div class="col-md-3">
          <a-form-item label="Country">
          <a-input
            placeholder="Country"
            v-decorator="['contact_country', {rules: [{ required: true, message: 'Please input a country!' }]}]"
          />
          </a-form-item>
        </div>
        <div class="col-md-3">
          <a-form-item label="Phone">
            <a-input
              placeholder="Phone"
              v-decorator="['contact_phone', {rules: [{ required: true, message: 'Please input a valid phone!', pattern: new RegExp(`^[0-9]{7,14}$`) }]}]"
              width="100%"
            >
            <a-select
                slot="addonBefore"
                v-decorator="[
                  'contact_country_code',
                  { initialValue: '91' }
                ]"
                style="width: 70px"
              >
                <a-select-option v-for="countryCode in countryCodes" :value="countryCode.value" :key="countryCode.value">
                  <span class="text-bold">{{countryCode.name}}</span>
                </a-select-option>
              </a-select>
            </a-input>
          </a-form-item>
        </div>

        <div class="col-md-3">
          <a-form-item label="Email">
            <a-input
              placeholder="Email"
              v-decorator="[
                'contact_email',
                {
                  rules: [{
                    type: 'email', message: 'The input is not valid email!',
                  }, {
                    required: false, message: 'Please input an email!',
                  }]
                }
              ]"
            />
          </a-form-item>
        </div>
      </div>

      <a-divider />
      <p class="neo_form_sub_heading pt-3">Contact Details <strong>(Permanent address)</strong></p>
      <div class="row">
        <div class="col">
          <a-form-item>
            <a-checkbox v-decorator="['permanent_same_as_present', { valuePropName: 'checked' }]">
              Permanent address is same as the present address
            </a-checkbox>
          </a-form-item>
        </div>
      </div>
      <div class="row pb-3" v-show="!form.getFieldValue('permanent_same_as_present')">
        <div class="col-md-9">
          <a-form-item label="Address">
          <a-input
            placeholder="Street address"
            v-decorator="['permanent_contact_address', {rules: [{ required: !form.getFieldValue('permanent_same_as_present'), message: 'Please input school address!' }]}]"
          />
          </a-form-item>
        </div>

        <div class="col-md-3">
          <a-form-item label="City">
          <a-input
            placeholder="City"
            v-decorator="['permanent_contact_city', {rules: [{ required: false, message: 'Please input city!' }]}]"
          />
          </a-form-item>
        </div>

        <div class="col-md-3">
          <a-form-item label="District">
          <a-input
            placeholder="District"
            v-decorator="['permanent_contact_district', {rules: [{ required: false, message: 'Please input a district!' }]}]"
          />
          </a-form-item>
        </div>

        <div class="col-md-3">
          <a-form-item label="Landmark">
          <a-input
            placeholder="Landmark"
            v-decorator="['permanent_contact_landmark',]"
          />
          </a-form-item>
        </div>

        <div class="col-md-3">
          <a-form-item label="Pincode">
          <a-input
            placeholder="Pincode"
            v-decorator="['permanent_contact_pincode', {rules: [{ required: false, message: 'Please input a pincode!' }]}]"
          />
          </a-form-item>
        </div>

        <div class="col-md-3">
          <a-form-item label="State">
          <a-input
            placeholder="State"
            v-decorator="['permanent_contact_state', {rules: [{ required: !form.getFieldValue('permanent_same_as_present'), message: 'Please input a state!' }]}]"
          />
          </a-form-item>
        </div>

        <div class="col-md-3">
          <a-form-item label="Country">
          <a-input
            placeholder="Country"
            v-decorator="['permanent_contact_country', {rules: [{ required: !form.getFieldValue('permanent_same_as_present'), message: 'Please input a country!' }]}]"
          />
          </a-form-item>
        </div>
        <div class="col-md-3">
          <a-form-item label="Phone">
            <a-input
              placeholder="Phone"
              v-decorator="['permanent_contact_phone', {rules: [{ required: false, message: 'Please input a valid phone!', pattern: new RegExp(`^[0-9]{7,14}$`) }]}]"
              width="100%"
            >
            <a-select
                slot="addonBefore"
                v-decorator="[
                  'permanent_contact_country_code',
                  { initialValue: '91' }
                ]"
                style="width: 70px"
              >
                <a-select-option v-for="countryCode in countryCodes" :value="countryCode.value" :key="countryCode.value">
                  <span class="text-bold">{{countryCode.name}}</span>
                </a-select-option>
              </a-select>
            </a-input>
          </a-form-item>
        </div>
      </div>

      <a-divider />
      <p class="neo_form_sub_heading pt-3">Parent Details <strong>(As per HSLC certificate or equivalent exam)</strong></p>

      <p class="font-weight-bold">Father's Details</p>
      <div class="row pb-3">
        <div class="col-md-2">
          <a-form-item label="Title">
          <a-select
              v-decorator="[
                'father_suffix',
                {rules: [{ required: true, message: 'A title is required!' }], initialValue: 'Mr'}
              ]"
            >
              <a-select-option v-for="nameSuffix in nameSuffixes" :value="nameSuffix.value" :key="nameSuffix.value">
              {{nameSuffix.name}}
              </a-select-option>
            </a-select>
          </a-form-item>
        </div>
        <div class="col-md-6">
          <a-form-item label="Full name">
          <a-input
            placeholder="FUll name"
            v-decorator="['father_first_name', {rules: [{ required: true, message: `Please father's full name!` }]}]"
          />
          </a-form-item>
        </div>
        <!-- <div class="col-md-4">
          <a-form-item label="Last name">
          <a-input
            placeholder="Last name"
            v-decorator="['father_last_name', {rules: [{ required: true, message: `Please father's last name!` }], initialValue: '.'}]"
          />
          </a-form-item>
        </div> -->

        <div class="col-md-4">
          <a-form-item label="Contact Phone">
            <a-input
              placeholder="Phone"
              v-decorator="['father_contact_phone', {rules: [{ required: false, message: 'Please input a valid phone!', pattern: new RegExp(`^[0-9]{7,14}$`) }]}]"
              width="100%"
            >
            <a-select
                slot="addonBefore"
                v-decorator="[
                  'father_contact_country_code',
                  { initialValue: '91' }
                ]"
                style="width: 70px"
              >
                <a-select-option v-for="countryCode in countryCodes" :value="countryCode.value" :key="countryCode.value">
                  <span class="text-bold">{{countryCode.name}}</span>
                </a-select-option>
              </a-select>
            </a-input>
          </a-form-item>
        </div>

        <div class="col-md-4">
          <a-form-item label="Whatsapp number">
            <a-input
              placeholder="Phone"
              v-decorator="['father_whatsapp_phone', {rules: [{ required: false, message: 'Please input a valid phone number!', pattern: new RegExp(`^[0-9]{7,14}$`) }]}]"
              width="100%"
            >
            </a-input>
          </a-form-item>
        </div>

        <div class="col-md-8" v-if="false">
          <a-form-item
            label="Qualification"
          >
            <a-radio-group
                v-decorator="[
                  'father_qualification',
                  {rules: [{ required: false, message: 'This value is required' }],  initialValue: 'GD' },
                ]"
              >
              <template v-for="qualification in qualifications">
                <a-radio :value="qualification.value" :key="qualification.value">{{ qualification.name }}</a-radio>
              </template>
            </a-radio-group>
          </a-form-item>
        </div>
        <div class="col-md-12" v-if="false">
          <a-form-item
            label="Occupation"
          >
            <a-radio-group
                v-decorator="[
                  'father_occupation',
                  {rules: [{ required: false, message: 'This value is required' }],  initialValue: 'UN' },
                ]"
              >
              <template v-for="occupation in occupations">
                <a-radio :value="occupation.value" :key="occupation.value">{{ occupation.name }}</a-radio>
              </template>
            </a-radio-group>
          </a-form-item>
        </div>
      </div>

      <p class="font-weight-bold mt-3">Mother's Details</p>
      <div class="row">
        <div class="col-md-2">
          <a-form-item label="Title">
          <a-select
              v-decorator="[
                'mother_suffix',
                {rules: [{ required: true, message: 'A title is required!' }], initialValue: 'Mr'}
              ]"
            >
              <a-select-option v-for="nameSuffix in nameSuffixes" :value="nameSuffix.value" :key="nameSuffix.value">
              {{nameSuffix.name}}
              </a-select-option>
            </a-select>
          </a-form-item>
        </div>
        <div class="col-md-6">
          <a-form-item label="Full name">
          <a-input
            placeholder="Full name"
            v-decorator="['mother_first_name', {rules: [{ required: true, message: `Please mother's full name!` }]}]"
          />
          </a-form-item>
        </div>
        <!-- <div class="col-md-4">
          <a-form-item label="Last name">
          <a-input
            placeholder="Last name"
            v-decorator="['mother_last_name', {rules: [{ required: true, message: `Please mother's last name!` }], initialValue: '.'}]"
          />
          </a-form-item>
        </div> -->

        <div class="col-md-4">
          <a-form-item label="Contact Phone">
            <a-input
              placeholder="Phone"
              v-decorator="['mother_contact_phone', {rules: [{ required: false, message: 'Please input a valid phone!', pattern: new RegExp(`^[0-9]{7,14}$`) }]}]"
              width="100%"
            >
            <a-select
                slot="addonBefore"
                v-decorator="[
                  'mother_contact_country_code',
                  { initialValue: '91' }
                ]"
                style="width: 70px"
              >
                <a-select-option v-for="countryCode in countryCodes" :value="countryCode.value" :key="countryCode.value">
                  <span class="text-bold">{{countryCode.name}}</span>
                </a-select-option>
              </a-select>
            </a-input>
          </a-form-item>
        </div>

        <div class="col-md-4">
          <a-form-item label="Whatsapp number">
            <a-input
              placeholder="Phone"
              v-decorator="['mother_whatsapp_phone', {rules: [{ required: false, message: 'Please input a valid phone number!', pattern: new RegExp(`^[0-9]{7,14}$`) }]}]"
              width="100%"
            >
            </a-input>
          </a-form-item>
        </div>

        <div class="col-md-8" v-if="false">
          <a-form-item
            label="Qualification"
          >
            <a-radio-group
                v-decorator="[
                  'mother_qualification',
                  {rules: [{ required: false, message: 'This value is required' }],  initialValue: 'GD' },
                ]"
              >
              <template v-for="qualification in qualifications">
                <a-radio :value="qualification.value" :key="qualification.value">{{ qualification.name }}</a-radio>
              </template>
            </a-radio-group>
          </a-form-item>
        </div>
        <div class="col-md-12" v-if="false">
          <a-form-item
            label="Occupation"
          >
            <a-radio-group
                v-decorator="[
                  'mother_occupation',
                  {rules: [{ required: false, message: 'This value is required' }],  initialValue: 'UN' },
                ]"
              >
              <template v-for="occupation in occupations">
                <a-radio :value="occupation.value" :key="occupation.value">{{ occupation.name }}</a-radio>
              </template>
            </a-radio-group>
          </a-form-item>
        </div>
      </div>

      <p class="font-weight-bold mt-3">Guardian's Details</p>
      <div class="row">
        <div class="col-md-2">
          <a-form-item label="Title">
          <a-select
              v-decorator="[
                'guardian_suffix',
                {rules: [{ required: false, message: 'A title is required!' }], initialValue: 'Mr'}
              ]"
            >
              <a-select-option v-for="nameSuffix in nameSuffixes" :value="nameSuffix.value" :key="nameSuffix.value">
              {{nameSuffix.name}}
              </a-select-option>
            </a-select>
          </a-form-item>
        </div>
        <div class="col-md-6">
          <a-form-item label="Full name">
          <a-input
            placeholder="Full name"
            v-decorator="['guardian_first_name', {rules: [{ required: false, message: `Please enter guardian's full name!` }]}]"
          />
          </a-form-item>
        </div>
        <!-- <div class="col-md-4">
          <a-form-item label="Last name">
          <a-input
            placeholder="Last name"
            v-decorator="['guardian_last_name', {rules: [{ required: false, message: `Please enter guardian's last name!` }]}]"
          />
          </a-form-item>
        </div> -->
        <div class="col-md-4">
          <a-form-item label="Relation with student">
          <a-input
            placeholder="Uncle, Aunt, etc."
            v-decorator="['guardian_relation_with_student', {rules: [{ required: form.getFieldValue(`guardian_first_name`), message: `Please enter a relation` }]}]"
          />
          </a-form-item>
        </div>

        <div class="col-md-4">
          <a-form-item label="Contact Phone">
            <a-input
              placeholder="Phone"
              v-decorator="['guardian_contact_phone', {rules: [{ required: false, message: 'Please input a valid phone!', pattern: new RegExp(`^[0-9]{7,14}$`) }]}]"
              width="100%"
            >
            <a-select
                slot="addonBefore"
                v-decorator="[
                  'guardian_contact_country_code',
                  { initialValue: '91' }
                ]"
                style="width: 70px"
              >
                <a-select-option v-for="countryCode in countryCodes" :value="countryCode.value" :key="countryCode.value">
                  <span class="text-bold">{{countryCode.name}}</span>
                </a-select-option>
              </a-select>
            </a-input>
          </a-form-item>
        </div>

        <div class="col-md-4">
          <a-form-item label="Whatsapp number">
            <a-input
              placeholder="Phone"
              v-decorator="['guardian_whatsapp_phone', {rules: [{ required: false, message: 'Please input a valid phone number!', pattern: new RegExp(`^[0-9]{7,14}$`) }]}]"
              width="100%"
            >
            </a-input>
          </a-form-item>
        </div>

        <div class="col-md-8" v-if="false">
          <a-form-item
            label="Qualification"
          >
            <a-radio-group
                v-decorator="[
                  'guardian_qualification',
                  {rules: [{ required: false, message: 'This value is required' }],  initialValue: 'O' },
                ]"
              >
              <template v-for="qualification in qualifications">
                <a-radio :value="qualification.value" :key="qualification.value">{{ qualification.name }}</a-radio>
              </template>
            </a-radio-group>
          </a-form-item>
        </div>
        <div class="col-md-12" v-if="false">
          <a-form-item
            label="Occupation"
          >
            <a-radio-group
                v-decorator="[
                  'guardian_occupation',
                  {rules: [{ required: false, message: 'This value is required' }],  initialValue: 'UN' },
                ]"
              >
              <template v-for="occupation in occupations">
                <a-radio :value="occupation.value" :key="occupation.value">{{ occupation.name }}</a-radio>
              </template>
            </a-radio-group>
          </a-form-item>
        </div>
      </div>

      <hr>
      <div class="row mb-0">
        <div class="col-md-6">
          <a-button
            type="primary"
            size="large"
            class="text-center btn btn-default font-weight-bold font-size-18 mt-2"
            :disabled="true"
          >Previous</a-button>
        </div>
        <div class="col-md-6 text-md-right">
          <a-button
            type="primary"
            htmlType="submit"
            size="large"
            class="text-center btn btn-primary font-weight-bold font-size-18 mt-2"
          >Save & Next</a-button>
        </div>
      </div>
    </a-form>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
import { makeFields } from './fields'
import { countryCodes, genderTypes, categoryTypes, qualifications, occupations, nameSuffixes } from '@/services/globaldata'

export default {
  name: 'FormStepTwo',
  props: ['applicantData', 'applicationFormData'],
  mounted() {
    this.setFormData()
  },
  data() {
    return {
      form: this.$form.createForm(this),
      dateFormat: 'DD-MM-YYYY',
      countryCodes,
      genderTypes,
      categoryTypes,
      qualifications,
      occupations,
      nameSuffixes,
    }
  },
  computed: {
    ...mapState(['applicant']),
  },
  methods: {
    moment,
    disabledDate(current) {
      // Can not select days after today
      return current > moment().endOf('day')
    },
    handleSubmit(e) {
      e.preventDefault()
      this.loading = true
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure?`,
            content: `Click on the OK button to save your personal data.`,
            onOk: () => {
              values.dob = moment(values.dob).format('YYYY-MM-DD')
              this.$http
                .patch(`/api/application-form/personal/${this.applicantData.id}`, values, {
                  params: {
                    token: this.applicant.app_form_token,
                  },
                })
                .then(({ data }) => {
                  if (data.type === 'error') {
                    this.$applicantAuth.logout()
                  } else {
                    this.$emit('saved')
                    this.loading = false
                    this.$notification['success']({
                      message: 'Successfully saved!',
                      description: `Your personal data has been saved successfully!`,
                    })
                  }
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }

        this.loading = false
      })
    },
    setFormData() {
      const fieldsData = makeFields(this.applicantData)
      this.form.setFieldsValue({ ...fieldsData })
    },
  },
}
</script>

<style>

</style>
